import { useState } from 'react';
import Toast from '../components/common/Toast';

export const useToast = () => {
  const [toast, setToast] = useState(null);

  const showToast = (message, type = 'info', duration = 3000) => {
    setToast({ message, type, duration });
  };

  const ToastContainer = () => {
    if (!toast) return null;

    return (
      <Toast
        message={toast.message}
        type={toast.type}
        duration={toast.duration}
        onClose={() => setToast(null)}
      />
    );
  };

  return { showToast, ToastContainer };
};
